import axios from 'axios';

const api = axios.create({
  baseURL: 'https://vision.useincline.com',
});

let getIdToken: (() => string | null) | null = null;

export function setTokenGetter(getter: () => string | null) {
  getIdToken = getter;
}

api.interceptors.request.use((config) => {
  const token = getIdToken?.();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;
